export enum EAgentBlankFormSession {
    HIBD = 'HIBD',
    HeadHI = 'headHI',
    BusinessDirector = 'businessDirector',
    ClosingAgent = 'ClosingAgent',
    Internal = 'Internal',
    TeamLeader = 'TeamLeader',
    Bonus = 'Bonus',
    Overriding = 'Overriding',
    Pool = 'Pool',
    InternalRefferal = 'InternalRefferal',
    PDOverride = 'PDOverride',
    PDReferral = 'PDReferral',
    PDManagement = 'PDManagement',
    OTHManagement = 'OTHManagement',
}